import { useEffect } from 'react';
import { useServerData } from '@xingternal/hops';
import { useXingFrame } from '@/hooks/useXingFrame';
import { trackPage } from '@/utils/tracking';

const useTrackPage = ({ pageName }: $TSFixMe) => {
  const {
    features: { isBrandManagerEditor },
  } = useXingFrame();

  const { authenticated } = useServerData();

  useEffect(() => {
    if (!authenticated || isBrandManagerEditor !== undefined) {
      const trackingParams = authenticated
        ? {
            PropContextDimension3: isBrandManagerEditor
              ? 'companies_editor'
              : 'companies_user',
          }
        : {};

      trackPage(pageName, {
        ...trackingParams,
      });
    }
  }, [isBrandManagerEditor, authenticated, pageName]);
};

export { useTrackPage };
